module.exports = __webpack_public_path__ + "static/media/service_programming_language_icons.f48bacb1.png";